import * as remote from './remotes';
import * as stub from './stubs';
import { endpoints } from './endpoints';
import { VerifyEligibility, CreateManifest, GetConfirmation, UpdateEmails } from './contracts';

type Sources = {
  verifyEligibility: VerifyEligibility;
  createManifest: CreateManifest;
  getConfirmation: GetConfirmation;
  updateEmails: UpdateEmails;
};

const stubs: Sources = {
  verifyEligibility: stub.VerifyEligibilityStub,
  createManifest: stub.CreateManifestStub,
  getConfirmation: stub.GetConfirmationStub,
  updateEmails: stub.UpdateEmailsStub,
};

const remotes: Sources = {
  verifyEligibility: remote.VerifyEligibilityApi(endpoints.verifyEligibility),
  createManifest: remote.CreateManifestApi(endpoints.createManifest),
  getConfirmation: remote.GetConfirmationApi(endpoints.getConfirmation),
  updateEmails: remote.UpdateEmailsApi(endpoints.updateEmails),
};

export const sources =
  process.env.NODE_ENV === 'production' || process.env.VITE_APP_SOURCES === 'remote' ? remotes : stubs; 
